import React from 'react';
import { Confirmation, Information } from './common';
import { messageUtility } from '../../utilities/messageUtility';
import { isForemanRoleId } from '../../utilities/roleUtility';

export const IntegrateError = ({
  reason,
  userRoleCode,
  isCreateNew = false,
  onConfirm,
  onCancel,
  title = 'アカウント統合できません',
  ...restProps
}) => {
  const isForeman = userRoleCode && isForemanRoleId(userRoleCode);

  const getMessage = () => {
    return (
      <div className='integrate-message'>
        入力したID（メールアドレス）のアカウントとは以下の理由により統合できません。
        <br />
        <br />
        <ul className='integrate-message__error'>
          <li>{reason}</li>
        </ul>
        <br />
        {isForeman &&
          (isCreateNew
            ? '「登録」ボタンを押してユーザーを登録するか、'
            : '「更新」ボタンを押してアカウントを更新するか、')}
        「閉じる」ボタンを押して別のメールアドレスを設定してください。
      </div>
    );
  };

  if (isForeman) {
    return (
      <Confirmation
        {...restProps}
        title={title}
        message={getMessage()}
        confirmButtonText={isCreateNew ? '登録' : '更新'}
        onConfirm={onConfirm}
        onCancel={onCancel}
        cancelButtonText={messageUtility.getMessage('I-000-017')}
        rootClassName='integrate-error'
        multilineText={true}
      />
    );
  }
  return (
    <Information
      {...restProps}
      title={title}
      onClose={onCancel}
      message={getMessage()}
      rootClassName='integrate-error'
      buttonText={messageUtility.getMessage('I-000-017')}
      multilineText={true}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/modals/IntegrateError.jsx